import Grid from "@mui/material/Grid";
import { Box, Skeleton } from "@mui/material";

export default function GridSkeleton() {
    return (
        <div style={{ width: '100%' }}>
            <Skeleton variant='rectangular' style={{ height: '45px', marginRight: '2px', marginBottom: '2px' }} animation="wave" />
            {[...Array(8)].map((_) => (
                <Grid container >
                    {[...Array(6)].map((value, index, array) => (
                        <Grid xs={2} height='51px' pr='2px'>
                            <Skeleton style={{ height: '49px' }} variant='rectangular' animation="wave" />
                        </Grid>
                    ))}
                </Grid>
            ))}
        </div>
    );
}